/* eslint-disable jsx-a11y/click-events-have-key-events */
import cx from 'classnames';
import { addMonths, getMonth, getYear, isSameMonth } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { getArrayMonth, getDisableDays, getEndSeasonDisabledDates, getFirstDeposableDate, } from '../helpers';
import { DepositMessage } from './DepositMessage/depositMessage';
import styles from './dialogContent.module.scss';
import MonthCalendar from './MonthCalendar';
const DialogContentDesktop = ({ fromDate, toDate, hoverDate, onSelectDate, onHoverDate, startWeekDay, minDate, maxDate, monthFormat, weekDayFormat, highlightToday, singleCalendar, singleColumn = false, seasons, duration, isAnyDaySelectable, disableUnusableDates = false, availableDates, leadingPrices, focusDate, setFocusDate, enableDepositInfo, showRelativePricing = false, }) => {
    const containerRef = useRef(null);
    const [translateAmount, setTranslateAmount] = useState(0);
    const [monthArray, setMonthArray] = useState([]);
    const [disablePrev, setDisablePrev] = useState(false);
    const [disableNext, setDisableNext] = useState(false);
    const [wrapperWidth, setWrapperWidth] = useState(0);
    const [firstDeposableDate, setFirstDeposableDate] = useState(null);
    useEffect(() => {
        function handleResize() {
            if (!(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current))
                return;
            const _translateAmount = singleCalendar
                ? containerRef.current.offsetWidth
                : containerRef.current.offsetWidth / 2;
            setWrapperWidth(_translateAmount);
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [containerRef, singleCalendar]);
    useEffect(() => {
        if (minDate && isSameMonth(focusDate, minDate)) {
            setDisablePrev(true);
        }
        else {
            setDisablePrev(false);
        }
        if (maxDate && isSameMonth(focusDate, maxDate)) {
            setDisableNext(true);
        }
        else {
            setDisableNext(false);
        }
        const arrayMonth = getArrayMonth(focusDate, singleCalendar);
        setMonthArray(arrayMonth);
    }, [focusDate, maxDate, minDate, singleCalendar]);
    function increaseFocusDate() {
        const nextDate = addMonths(focusDate, 1);
        setFocusDate(nextDate);
    }
    function decreaseFocusDate() {
        const prevDate = addMonths(focusDate, -1);
        setFocusDate(prevDate);
    }
    function increaseCurrentMonth() {
        if (disableNext)
            return;
        setTranslateAmount(-wrapperWidth);
        increaseFocusDate();
    }
    function decreaseCurrentMonth() {
        if (disablePrev)
            return;
        setTranslateAmount(wrapperWidth);
        decreaseFocusDate();
    }
    useEffect(() => {
        setTranslateAmount(0);
    }, [focusDate]);
    useEffect(() => {
        const deposableDate = getFirstDeposableDate(fromDate, leadingPrices);
        setFirstDeposableDate(deposableDate);
    }, [duration, fromDate, leadingPrices]);
    function focusOnCalendar() {
        if (containerRef && containerRef.current) {
            let selectedButton = containerRef.current.querySelector('.day.selected');
            if (!selectedButton) {
                selectedButton = containerRef.current.querySelector('.month-calendar:not(.hidden) .day:not(.disabled)');
            }
            if (selectedButton) {
                selectedButton.focus();
            }
        }
    }
    const disabledDays = isAnyDaySelectable ? [] : getDisableDays(duration);
    const endSeasonDisabledDates = getEndSeasonDisabledDates(duration, seasons);
    const handleDeposableDateClick = (date) => {
        onSelectDate(date);
        setFocusDate(date);
    };
    const showDepositInfo = enableDepositInfo && leadingPrices;
    function renderMonthCalendars() {
        return monthArray.map((date, dateIndex) => (<MonthCalendar 
        // eslint-disable-next-line react/no-array-index-key
        key={dateIndex} hidden={dateIndex === 0 && translateAmount <= 0} isAnimating={dateIndex === 0 && translateAmount > 0} month={getMonth(date)} year={getYear(date)} onSelectDate={onSelectDate} onHoverDate={onHoverDate} fromDate={fromDate} toDate={toDate} hoverDate={hoverDate} showRelativePricing={showRelativePricing} startWeekDay={startWeekDay} minDate={minDate} maxDate={maxDate} weekDayFormat={weekDayFormat} monthFormat={monthFormat} highlightToday={highlightToday} availableDates={availableDates} singleCalendar={singleCalendar} leadingPrices={leadingPrices} seasons={seasons} isInventoryDrivenCalendarEnabled={!!(availableDates === null || availableDates === void 0 ? void 0 : availableDates.length)} disabledDays={disabledDays} endSeasonDisabledDates={disableUnusableDates ? endSeasonDisabledDates : []} isLeadingPricesEnabled={!!(leadingPrices === null || leadingPrices === void 0 ? void 0 : leadingPrices.length)}/>));
    }
    return (<div className={cx(styles.calendarWrapper, singleColumn && styles.calendarWrapperSingleColumn)} ref={containerRef}>
      <div className={cx(styles.calendarContent, translateAmount !== 0 && styles.isAnimating, singleCalendar && styles.single)} style={{
            transform: `translateX(${translateAmount}px)`,
        }}>
        {renderMonthCalendars()}
      </div>
      {showDepositInfo && (<DepositMessage firstDeposableDate={firstDeposableDate} handleDeposableDateClick={handleDeposableDateClick}/>)}
      {!!(leadingPrices === null || leadingPrices === void 0 ? void 0 : leadingPrices.length) && (<div className={styles.leadingPricesWarning}>
          Prices are estimated and subject to availability.
        </div>)}
      <div className={styles.calendarFlippers}>
        <div className={cx(styles.flipperButton, styles.flipperButtonPrev, disablePrev && styles.flipperButtonDisabled)} onClick={() => decreaseCurrentMonth()} role='button' tabIndex={0}>
          <span className='srOnly'>Previous</span>
        </div>
        <div className={cx(styles.flipperButton, styles.flipperButtonNext, disableNext && styles.flipperButtonDisabled)} onClick={() => increaseCurrentMonth()} role='button' tabIndex={0} onBlur={focusOnCalendar}>
          <span className='srOnly'>Next</span>
        </div>
      </div>
    </div>);
};
export default DialogContentDesktop;
